<template>
  <div class="header-container">
    <div class="header-shadow">
      <slot/>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'bo-header'
  };
</script>
<style lang="scss" src="./bo-header.scss"></style>
